// User-facing copy for the Attendance feature. Reason labels stay in
// `attendance.constants.ts`: they feed a select as plain strings, which this
// codebase has no mechanism to translate (see "String-attribute copy stays
// English" in the repo CLAUDE.md for why there is no `formatMessage` here).

import { defineMessages } from 'react-intl';

import { pluralTerm } from '../../lib/helpers/term.helper';
import { SportTermLookup, SportTerminology } from '../../lib/types';

export const scope = 'app.components.Attendance';

// Term-free copy, so list-row components can read it without subscribing every
// row to the sport-terminology store.
export const messages = defineMessages({
  statusAttending: {
    id: `${scope}.statusAttending`,
    defaultMessage: 'Attending',
  },
  statusPending: {
    id: `${scope}.statusPending`,
    defaultMessage: 'Pending',
  },
  statusNotAttending: {
    id: `${scope}.statusNotAttending`,
    defaultMessage: 'Not attending',
  },
});

// `satisfies` makes a newly-added AttendanceStatus a compile error here rather
// than an untranslated badge at runtime.
export const RSVP_STATUS_MESSAGES = {
  attending: messages.statusAttending,
  pending: messages.statusPending,
  not_attending: messages.statusNotAttending,
} satisfies Record<AttendanceStatus, unknown>;

// RSVP copy for the FormikSettingCheckbox at each scope it renders at: the
// per-session pair, and a variant for each default toggle.
export const getMessages = (termLookup: SportTermLookup) => {
  const athleteTerm = termLookup[SportTerminology.ATHLETE].toLowerCase();
  const athletesTitle = pluralTerm(termLookup[SportTerminology.ATHLETE]);
  const sessionsTerm = pluralTerm(termLookup[SportTerminology.SESSION].toLowerCase());
  return defineMessages({
    lblRequestRsvps: {
      id: `${scope}.lblRequestRsvps`,
      defaultMessage: `Request RSVPs from ${pluralTerm(athleteTerm)}`,
    },
    captionRequestRsvps: {
      id: `${scope}.captionRequestRsvps`,
      defaultMessage: `${athletesTitle} will receive a link to confirm attendance via email or SMS.`,
    },
    lblRequestRsvpsDefault: {
      id: `${scope}.lblRequestRsvpsDefault`,
      defaultMessage: `Request RSVPs from ${pluralTerm(athleteTerm)} by default`,
    },
    captionRequestRsvpsAssessmentDefault: {
      id: `${scope}.captionRequestRsvpsAssessmentDefault`,
      defaultMessage: `New ${sessionsTerm} in this assessment will request attendance confirmation by default. While left unset (—), the association-level default applies instead.`,
    },
    captionRequestRsvpsAssociationDefault: {
      id: `${scope}.captionRequestRsvpsAssociationDefault`,
      defaultMessage: `New ${sessionsTerm} created in this association will request attendance confirmation by default. Existing ${sessionsTerm} are unaffected.`,
    },
  });
};
